import React from 'react';
import { Helmet } from 'react-helmet-async';
import bagshotOfficesOutside from '../../assets/images/bagshot-offices-outside.webp';
import './About.css';

export const About: React.FC = () => {
  return (
    <div className="about-container">
      <Helmet>
        <title>About Us | Small Offices to Let in Bagshot</title>
        <meta name="description" content="Learn about our high-specification small office units to let right in the centre of Bagshot, built by a chartered engineer with parking and Wi-Fi." />
        <link rel="canonical" href="https://www.bagshot-offices.co.uk/about" />
      </Helmet>
      
      <div className="about-hero">
        <h1>About Bagshot Offices</h1>
        <p className="about-intro">
          Welcome to Bagshot Offices. Discover our high-specification workspace in the heart of Bagshot.
        </p>
      </div>

      <div className="about-image-banner">
        <img src={bagshotOfficesOutside} alt="Bagshot Offices Exterior" />
      </div>

      <div className="about-features-grid">
        <div className="about-card">
          <h3>Prime Location & Architecture</h3>
          <ul>
            <li>Located right in the centre of Bagshot.</li>
            <li>Built by a chartered engineer to a very high standard.</li>
            <li>Offices overlook the square.</li>
          </ul>
        </div>

        <div className="about-card">
          <h3>Specification & Space</h3>
          <ul>
            <li>Warm and very well insulated.</li>
            <li>8 office units in total, with options to merge for more space.</li>
          </ul>
        </div>

        <div className="about-card">
          <h3>Facilities & Kitchen</h3>
          <ul>
            <li>Premium kitchen with high-end appliances (induction hob, fridge, dishwasher, etc.).</li>
            <li>2 bathrooms with one shower.</li>
          </ul>
        </div>

        <div className="about-card">
          <h3>Parking & Connectivity</h3>
          <ul>
            <li>Parking around the back for multiple vehicles.</li>
            <li>High-speed Wi-Fi is already provided and ready to use.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
